import { flow, map, kebabCase } from 'lodash/fp';
import prepareOptions from '../../prepareOptions';
import {
  CHASSIS_CAB,
  PANEL_VAN_HIGH,
  PANEL_VAN_HIGH_LONG,
  PANEL_VAN_LONG,
  TRUCK_WITH_BOX_BODY,
  PLATFORM_CAB,
  TIPPER,
  PANEL_VAN,
  BUS,
  OTHER_COMMERCIAL,
} from './values';

const options = [
  {
    label: __('carDetails.bodyType.chassisCab'),
    value: CHASSIS_CAB,
  },
  {
    label: __('carDetails.bodyType.panelVanHigh'),
    value: PANEL_VAN_HIGH,
  },
  {
    label: __('carDetails.bodyType.panelVanHighLong'),
    value: PANEL_VAN_HIGH_LONG,
  },
  {
    label: __('carDetails.bodyType.panelVanLong'),
    value: PANEL_VAN_LONG,
  },
  {
    label: __('carDetails.bodyType.truckBoxBody'),
    value: TRUCK_WITH_BOX_BODY,
  },
  {
    label: __('carDetails.bodyType.platformCab'),
    value: PLATFORM_CAB,
  },
  {
    label: __('carDetails.bodyType.tipper'),
    value: TIPPER,
  },
  {
    label: __('carDetails.bodyType.panelVan'),
    value: PANEL_VAN,
  },
  {
    label: __('carDetails.bodyType.bus'),
    value: BUS,
  },
  {
    label: __('carDetails.bodyType.otherCommercial'),
    value: OTHER_COMMERCIAL,
  },
];

export default flow(
  prepareOptions,
  map(({ value, ...rest }) => ({
    ...rest,
    value,
    bodyType: kebabCase(value),
  })),
)(options);
